var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComplain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 55.25C12.9502 55.25 0.75 43.0498 0.75 28C0.75 12.9502 12.9502 0.75 28 0.75C43.0498 0.75 55.25 12.9502 55.25 28C55.25 43.0498 43.0498 55.25 28 55.25Z",
    fill: "white",
    stroke: "#272726",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1182 33.7851C15.6827 34.3741 16.4059 34.7595 17.1831 34.8962C17.3915 34.9329 18.5677 35.1315 19.3261 34.857C19.6016 34.7114 19.7904 34.4132 19.7904 34.0691V25.3906C19.7904 20.6604 23.466 16.8257 28 16.8257C32.534 16.8257 36.2096 20.6604 36.2096 25.3906V34.0691C36.2096 34.5565 36.5883 34.9517 37.0556 34.9517H38.1822C39.1947 34.9517 40.1658 34.5321 40.8818 33.7851C41.5978 33.0381 42 32.025 42 30.9686V28.5414C42 27.485 41.5978 26.4719 40.8818 25.7249C40.1658 24.978 39.1947 24.5583 38.1822 24.5583H37.9281C37.5219 19.2091 33.2321 15 28 15C22.7679 15 18.4781 19.2091 18.0719 24.5583H17.8178C16.8053 24.5583 15.8342 24.978 15.1182 25.7249C14.4022 26.4719 14 27.485 14 28.5414V30.9686C14 32.025 14.4022 33.0381 15.1182 33.7851ZM18 36C18.3127 36.0223 18.6911 36.0351 19.0711 36.0144C19.2736 36.9733 19.7766 37.8627 20.5274 38.5639C21.5242 39.4948 22.876 40.0177 24.2856 40.0177H25C24.9685 40.1787 24.9523 40.343 24.9523 40.5089C24.9523 40.6766 24.9685 40.8408 24.9995 41H24.2856C22.5971 41 20.9776 40.3736 19.7837 39.2585C18.8312 38.3689 18.2116 37.2264 18 36ZM29.1393 42C30.1669 42 31 41.1045 31 40C31 38.8955 30.1669 38 29.1393 38H26.8607C26.3672 38 25.894 38.2107 25.545 38.5858C25.1961 38.9609 25 39.4696 25 40C25 41.1045 25.8331 42 26.8607 42H29.1393Z",
    fill: "#2B2B2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplain);
export default __webpack_public_path__ + "static/media/complain.5a532b7df96fba164e84ddc3b8eb453c.svg";
export { ForwardRef as ReactComponent };